import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "measurements-selector__sub-section" }

import { computed, onBeforeUnmount } from 'vue';
import { useStore } from "vuex";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import Length from '../../../source/js/shared/models/Geometry/Length';
import ValidationMessage from "@/components/UI/ValidationMessage.vue";
import { endsWithSeparator, limitDecimals } from "@/functions/numbers";
import { addSizeToDataLayer } from "@/functions/analytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrillHolePreset',
  setup(__props) {

const $i18n = window.measurementSelectorVariables.i18n;

const store = useStore();
const drillHoleDiameter = computed(() => store.getters.drillHoleDiameter.in_cm() );
const isDrillHoleValid = computed(() => store.getters.isDrillHoleValid);
const drillHoleValidationMessage = computed(() => store.getters.getDrillHoleValidationMessage);
const minimumDrillHoleDiameter = computed(() => store.getters.minimumDrillHoleDiameter );
const minimumDrillHoleDiameterLabel = computed(() => store.getters.minimumDrillHoleDiameterLabel );

function onUpdate( value: string ) {
	if ( ! endsWithSeparator( value ) ) {
		store.commit( `updateDrillHoleDiameter`, Length.from_cm( limitDecimals( value, 1 ) ).in_mm() );
		store.commit( 'updateUsingDefaultDrillHoleDimensions', false );
	}
}

document.addEventListener('focusin', (event) =>
	store.commit('updateFocusedElement', event)
);

onBeforeUnmount(() => {
	document.removeEventListener('focusin', () =>
		store.commit('updateFocusedElement')
	);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DimensionInput, {
      class: "drill-hole-input",
      inputRef: "drillHoleDiameter",
      id: "measurements-drillHoleDiameter",
      name: "drillHoleDiameter",
      unit: "cm",
      min: minimumDrillHoleDiameter.value,
      label: `${_unref($i18n).drillHoleConfiguration.diameter_drill_hole} (${minimumDrillHoleDiameterLabel.value})`,
      invalid: !isDrillHoleValid.value('drillHoleDiameter'),
      onBlur: () => _unref(addSizeToDataLayer)( 'drillHoleDiameter', drillHoleDiameter.value, 'preset-drill-holes' ),
      modelValue: drillHoleDiameter.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((drillHoleDiameter).value = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (onUpdate($event)))
      ]
    }, null, 8, ["min", "label", "invalid", "onBlur", "modelValue"]),
    (!isDrillHoleValid.value('drillHoleDiameter'))
      ? (_openBlock(), _createBlock(ValidationMessage, {
          key: 0,
          "input-id": "drillHoleDiameter"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(drillHoleValidationMessage.value('drillHoleDiameter')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})